<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <g fill="currentColor">
      <path
        d="M17.8 7.6c-.1-.4-.3-.6-.6-.9-.3-.3-.5-.4-.9-.6-.3-.1-.7-.2-1.4-.3h-6c-.7.1-1.1.2-1.3.4-.4.1-.6.3-.9.5-.2.3-.4.5-.5.9-.1.2-.3.6-.3 1.4v6c0 .7.2 1.1.3 1.4.1.4.3.6.6.9.3.3.5.4.9.6.3.1.7.2 1.4.3h6c.7 0 1.1-.2 1.4-.3.4-.1.6-.3.9-.6.3-.3.4-.5.6-.9.1-.3.2-.7.3-1.4v-3-3c-.2-.8-.3-1.2-.5-1.4zM12 15.9c-2.1 0-3.9-1.7-3.9-3.9S9.9 8.1 12 8.1s3.9 1.7 3.9 3.9-1.8 3.9-3.9 3.9zm4.9-7.7c0 .2-.1.3-.2.5-.1.1-.3.2-.5.2s-.4 0-.5-.1c-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.5s.1-.5.3-.6c.2-.2.4-.3.6-.3.2 0 .4.1.5.2.1.1.3.2.3.4s.1.3.1.5z"
      />
      <path d="M12 9.5c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5z" />
      <path
        d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm7.5 15.1c0 .8-.2 1.3-.3 1.8-.2.5-.4.9-.9 1.3-.4.4-.8.7-1.3.9-.5.2-1 .3-1.8.3H9c-.8 0-1.3-.2-1.8-.3-.5-.2-.9-.4-1.3-.9-.4-.4-.7-.8-.9-1.3-.2-.5-.3-1-.3-1.8V12 8.9c0-.8.2-1.3.3-1.8.2-.5.4-.9.9-1.3.4-.4.8-.7 1.3-.9.5-.2 1-.3 1.8-.3h6.2c.8 0 1.3.2 1.8.3.5.2.9.4 1.3.9.4.4.7.8.9 1.3.2.5.3 1 .3 1.8v6.2z"
      />
    </g>
  </svg>
</template>
